import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCocktail: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cocktail, drink"><path d="M12 13.0147L2.75 3.75H21.25L12 13.0147Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 13.0146V21.2499" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 21.25H12H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCocktail;
